import React from "react";
//import PragatiLogo from "./../../../../assets/pragati-tag.svg";
import PragatiLogo from "./../../../../assets/PRAGATI.svg";

export const Pragati = ({ className, title, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={PragatiLogo} />
    </div>
  ) : null;
};
